module.exports = __webpack_public_path__ + "static/media/indulge.942879c1.png";